import { observable, computed, action, makeObservable } from 'mobx'
import StaffCollection from '../Collections/StaffCollection'
import ProjectCollection from '../Collections/ProjectCollection'
import PhaseCollection from '../Collections/PhaseCollection'
import TaskCollection from '../Collections/TaskCollection'
import Model from './Model'
import WeeklyAllocationCollection from '../Collections/WeeklyAllocationCollection'
import CostCentreCollection from '../Collections/CostCentreCollection'
import { format, parse, startOfISOWeek } from 'date-fns'
import RoleCollection from '../Collections/RoleCollection'

class WeeklyAllocationModel extends Model {
    @observable staffId = null
    @observable roleId = null
    @observable projectId = null
    @observable phaseId = null

    @observable week = format(new Date(), 'RRRR-II')
    @observable numMinutes = 0
    @observable startMinutes = 0

    @observable pay = 0
    @observable cost = 0
    @observable charge_out = 0

    constructor(data, options) {
        super()
        makeObservable(this)
        this.collection = WeeklyAllocationCollection
        this.init(data, options)
    }
    @computed
    get staff() {
        return StaffCollection.staffsById[this.staffId]
    }
    @computed
    get role() {
        return RoleCollection.rolesById[this.roleId] || this.staff?.role
    }
    @computed
    get costCentre() {
        return this.project.costCentre
    }
    @computed
    get project() {
        return ProjectCollection.modelsById[this.projectId]
    }
    @computed
    get phase() {
        return PhaseCollection.modelsById[this.phaseId]
    }
    @computed
    get hours() {
        return this.numMinutes / 60
    }
    @computed
    get payRate() {
        return this.pay / this.hours
    }
    @computed
    get costRate() {
        return this.cost / this.hours
    }
    @computed
    get chargeOutRate() {
        return this.chargeOut / this.hours
    }
    @computed
    get month() {
        return format(this.date, 'yyyy-MM')
    }
    @computed
    get date() {
        return startOfISOWeek(
            parse(this.week, 'RRRR-II', new Date(), { weekStartsOn: 1 })
        )
    }
    @computed
    get likelihood() {
        return this.phase?.likelihood || 100
    }
}

export default WeeklyAllocationModel
